module.exports = __webpack_public_path__ + "img/bad.14f40756.svg";